import { useState,useEffect } from "react"
import { ToggleTheme } from "./toggle-theme.jsx"
import About from "./about.jsx";
import Coffee from "./donateCoffee.jsx";

import { ToggleLite } from "./toggle-lite.jsx";
import dateFormat from "dateformat";

import '../css/index.css'
import '../css/calc-overlay.css'


const CalcOverlay = ({isDark,setIsDark, isLite, setIsLite, showAbout, setShowAbout, fIn, fOut, secIn, minIn}) => {

    const coffeeOnScreen = 10 //seconds
    const coffeeRepeat = 40 //minutes

    const messageList = [
        '*Initial frame is lower than final frame',
        'Rendering 65 frames will be finish around'
    ]
    const summaryLines = [
        'Rendering ',
        ' frames should be done around '
    ]

    // const [now, setNow ] = useState(new Date())
    const [frameOut, setFrameOut] = useState(0)
    const [frameIn, setFrameIn] = useState(0)
    const [minutes, setMinutes] = useState(0)
    const [seconds, setSeconds] = useState(0)
    const [printAlert, setPrintAlert] = useState(false)

    const [printSummary, setPrintSummary] = useState(false)

    const [alert, setAlert] = useState('')

    const [resultHrs, setResultHrs] = useState(0)
    const [resultMin, seResulttMin] = useState(0)
    const [resultSec, setResultSec] = useState(0)
    const [totalFrames, setTotalFrames] = useState(0)
    const [summaryTime, setSummaryTime] = useState('')

    const [showCoffee, setShowCoffee] = useState(false);
    const [coffeeOpen, setCoffeeOpen] = useState(false);

    useEffect(() => {
        
        let now = new Date()
        let calcSummTime = ''
        let calcFrames = frameOut - frameIn + 1

        let totalSecs = calcFrames * ((minutes*60)+seconds)

        let tempHrs = Math.floor(totalSecs / 3600)

        let tempMins = Math.floor((totalSecs % 3600) / 60)
        
        let endRender = new Date(now.getTime() + (totalSecs*1000))

        // SUMMARY CREATION
        if(totalSecs<86400){
            calcSummTime = dateFormat(endRender, 'hh'+':'+'MM'+' TT')
        }else if(totalSecs<172800){
            calcSummTime = 'tomorrow ' + dateFormat(endRender, 'hh'+':'+'MM'+' TT')
        }else{
            calcSummTime = dateFormat(endRender, 'dddd'+' '+'hh'+' TT')
        }


        // Alert: Out lower than In
        if( frameOut - frameIn < 0 ){
            setTimeout(()=>{setPrintAlert(true)}, 2000)
            setAlert(messageList[0])
        }else{
            setPrintAlert(false) 
        }
        // Convert minutes to hrs
        if(tempMins===60){
            tempMins -= 60
            tempHrs += 1
        }
        setResultHrs(tempHrs)
        seResulttMin(tempMins)
        setResultSec(totalSecs%60)
        setPrintSummary(true)
        setSummaryTime(calcSummTime)
        setTotalFrames(calcFrames)

    });

    const triggerCoffee = () => {
        if (showAbout) return; // 🚫 don't show coffee when About is open

        setShowCoffee(true);
        setCoffeeOpen(false);

        // delay for intro animation
        setTimeout(() => {
            setCoffeeOpen(true);
        }, 50);

        // close animation
        setTimeout(() => {
            setCoffeeOpen(false);
        }, coffeeOnScreen * 1000);

        // unmount after animation
        setTimeout(() => {
            setShowCoffee(false);
        }, coffeeOnScreen * 1000 + 600);
    };

    useEffect(() => {
    const timer = setTimeout(() => {
        triggerCoffee();
    }, 1500); // wait for camera

    return () => clearTimeout(timer);
}, []);

     useEffect(() => {
    const interval = setInterval(() => {
        triggerCoffee();
    }, coffeeRepeat * 60 * 1000);

    return () => clearInterval(interval);
}, []);       

        
    return( 
        <> 
        <div className="calc-overlay" >

          
            <div className="about-frame" data-version={isLite?"lite":"full"}>
                <div className="about" style={{transform:showAbout?'translateX(0%)':'translateX(100%)'}}><About showAbout setShowAbout={setShowAbout} isDark={isDark} isLite={isLite}/></div>
            </div>
            <div className="calc-frame" data-version={isLite?"lite":"full"}>
            
                    <img src={isDark?'img/rt_square.svg':'img/rt_square.svg'} alt="Render Time Logo" className="squareIcon"/>
                    <div className="calc-header-menu">

                        {/* Coffee Button */}
                         {showCoffee && (<div className="coffeeMask" style={{display:showAbout?'none':'flex'}}><div className={`coffeeWrapper ${coffeeOpen ? 'open' : ''}`}><Coffee isDark={isDark} /></div></div>)}
                        
                        <div className="calc-header-link" onClick={()=>setShowAbout(!showAbout)}>{showAbout?'HOME':'INFO'}</div> 
                        <ToggleTheme isChecked={isDark} handleChange={() => setIsDark(!isDark)}/>
                        <ToggleLite isChecked={isLite} handleChange={() => setIsLite(!isLite)}/>
                    </div>
                
                <div className="calc-body" style={{opacity:showAbout?1:1, transform:isLite?showAbout?'translateX(-20%)':'translateX(0%)':showAbout?'translateX(80%)':'translateX(0%)'}}>
                    <div className="calc-content">
                    <img src={isDark?'img/rt_banner_4_night.svg':'img/rt_banner_4_day.svg'} alt="Title" className="subTitle" />
                        <div className="rndrInputs">
                            <div className="inputGroup" style={{backgroundColor:'#333333'}}>
                                <div className="inputLabel">FRAMES</div>
                                <div className="inputGroupFrames">
                                    <input type="number"name="frameIn" className="inputForm" onChange={(e)=>setFrameIn(e.target.value*1)} style={{fontSize:frameIn>999?'2.5em':'4em'}} placeholder="IN" min="0" tabIndex={showAbout?'-1':'0'}/>
                                    <div style={{color:'#ffffff',fontSize:'2em',opacity:0.3,userSelect: "none"}}>{'>'}</div>
                                    <input type="number"name="frames" className="inputForm" onChange={(e)=>setFrameOut(e.target.value*1)} style={{fontSize:frameOut>999?'2.5em':'4em'}} placeholder="OUT" min="0"  tabIndex={showAbout?'-1':'0'}/>
                                </div>
                            </div>
                            <div className="inputGroup">
                                <div className="inputLabel">Minutes</div>
                                <input type="number" name="minutes" className="inputForm" onChange={(e)=>setMinutes(e.target.value*1)} placeholder="0m" min="0"  tabIndex={showAbout?'-1':'0'}/>
                            </div>
                            <div className="inputGroup">
                                <div className="inputLabel">Seconds</div>
                                <input type="number" name="seconds" className="inputForm" onChange={(e)=>setSeconds(e.target.value*1)} placeholder="0s" min="0" max="59"  tabIndex={showAbout?'-1':'0'}/>
                            </div>
                        </div>
                        <div className="calcAlert" style={{opacity:printAlert?1:0, display:printAlert?'flex':'none'}}>{alert}</div>
                    
                        <div className="rndrResult"  style={{opacity:resultHrs>0||resultMin>0||resultSec>0?1:0, transform:resultHrs>0||resultMin>0||resultSec>0?'translateY(0%)':'translateY(-80%)'}}>
                            <div className="rndrTime">
                                <div className="resultNumber" style={{display:resultHrs<1?'none':'inline'}}>{resultHrs}<span className="resultUnit">h</span></div>
                                <div className="resultNumber" style={{display:resultMin<1?'none':'inline'}}><span style={{display:resultHrs>0&&resultMin<10?'inline':'none'}}>0</span>{resultMin}<span className="resultUnit">m</span></div>
                                <div className="resultNumber" style={{display:resultSec<1?'none':'inline'}}><span style={{display:resultMin>0&&resultSec<10?'inline':'none'}}>0</span>{resultSec}<span className="resultUnit">s</span></div>
                            </div>
                            <div className="underline" style={{display:resultHrs>0||resultMin>0||resultSec>0?'inline':'none'}}></div>

                            {printSummary
                            ?
                            <div className="summary" style={{opacity:resultHrs>0||resultSec>0||resultMin>0?1:0}}>{summaryLines[0]}<span className="summaryNumber">{totalFrames}</span>{summaryLines[1]}<span className="summaryNumber">{summaryTime}</span></div>
                            :
                            null
                            }
                        </div>
                    </div>
                </div>       
                {/* <div className="about" style={{transform:showAbout?'translateX(0%)':'translateX(100%)'}}><About showAbout setShowAbout={setShowAbout} isDark={isDark} isLite={isLite}/></div> */}

            </div>
             

            <div className="footer">rendertime.app</div>
        </div>

       
        </>
    )
}
 
export default CalcOverlay;